<template>
  <div>
    <Modal :title="title" v-model="portEditModal" width="1000" @on-cancel="formReset" :mask-closable="false">
      <Alert type="error" v-show="errorMsgShow" show-icon>{{ errorMsg }}</Alert>
      <div class="port-edit-form">
        <Form ref="changeForm" :model="changeForm" style="padding-right: 10px" :rules="changeRule">
          <FormItem label="端口名称" prop="name">
            <Input v-model="changeForm.name" placeholder="请填写端口名称" :maxlength="128"/>
          </FormItem>
          <FormItem label="启用管理员状态" popr="admin_state_up">
            <i-switch v-model="changeForm.admin_state_up">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="设备ID">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>连接到端口的设备ID</p>
              </div>
            </tooltip>
            <Input v-model="changeForm.device_id" placeholder="" :maxlength="255"/>
          </FormItem>
          <FormItem label="设备所属者">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>绑定在这个端口上的设备的所有者</p>
              </div>
            </tooltip>
            <Input v-model="changeForm.device_owner" placeholder="" :maxlength="128"/>
          </FormItem>
          <FormItem label="指定子网">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>如指定子网（但未指定IP地址），系统将从指定的子网内选取可用IP地址</p>
                <p>如不指定子网，系统将自动选取一个网络内可用的子网IP地址</p>
              </div>
            </tooltip>
            <br/>
            <Row v-for="(item, index) in changeForm.fixed_ips" :key="'fixed_ips_' + index" style="margin-bottom: 5px">
              <FormItem label="" :prop="'fixed_ips[' + index + '].subnet_id'"
                        :rules="{required: true, message: '请选择子网', trigger: 'change'}"
                        style="float: left; margin-right: 10px; margin-bottom: 10px">
                <Select clearable style="width: 250px;" placeholder="子网(必选)" v-model="item.subnet_id" size="small">
                  <Option v-for="subNetItem in subNetList" :key="subNetItem.id" :value="subNetItem.id">{{ subNetItem.name }} - {{ subNetItem.cidr }}</Option>
                </Select>
              </FormItem>
              <FormItem style="float:left; margin-right: 10px; margin-bottom: 10px">
                <Input v-model="item.ip_address" placeholder="IP地址(选填)" size="small" style="width: 250px;" />
              </FormItem>
              <Tooltip content="移除固定IP" style="float: left;">
                <a v-on:click="removeFixedIpItem(index)" style="color: #515a6e; margin-left: 10px"><Icon type="md-close" size=15 /></a>
              </Tooltip>
            </Row>
            <Row style="margin-top: 10px">
              <a v-on:click="addFixedIpItem()">添加固定IP</a>
            </Row>
          </FormItem>
          <FormItem label="MAC地址" prop="mac_address">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>指定这个新端口的MAC地址</p>
              </div>
            </tooltip>
            <Input v-model="changeForm.mac_address" placeholder="" :maxlength="128"/>
          </FormItem>
          <FormItem label="绑定：主机" prop="binding_host_id">
            <tooltip placement="right" transfer max-width="200">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>端口被分配到的目标主机ID 。某些情况下，不同实现方式可在运行在不同的主机上。</p>
              </div>
            </tooltip>
            <Input v-model="changeForm.binding_host_id" placeholder="" :maxlength="255"/>
          </FormItem>
          <FormItem label="端口安全" popr="port_security_enabled">
            <tooltip placement="right" transfer max-width="200" style="margin-right: 10px">
              <Icon type="ios-help-circle-outline" size="18" />
              <div slot="content">
                <p>对这个端口启用防欺诈策略</p>
              </div>
            </tooltip>
            <i-switch v-model="changeForm.port_security_enabled">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="绑定：VNIC类型" prop="binding_vnic_type">
            <Select v-model="changeForm.binding_vnic_type">
              <Option value="normal" key="normal">正常</Option>
              <Option value="direct" key="direct">直连</Option>
              <Option value="direct-physical" key="direct-physical">直连物理硬件</Option>
              <Option value="macvtap" key="macvtap">MacVTap</Option>
              <Option value="baremetal" key="baremetal">裸金属</Option>
              <Option value="virtio-forwarder" key="virtio-forwarder">Virtio 转发器</Option>
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="changeSubmit" :loading="changeLoading">提交</Button>
        <Button @click="portEditModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { changePrivateCloudPort, detailPrivateCloudPort } from '@/api/private-cloud/port'
import { getPrivateCloudAllSubnet } from '@/api/private-cloud/subnet'
export default {
  name: 'port-edit',
  data () {
    return {
      portEditModal: false,
      changeLoading: false,
      title: '创建端口',
      errorMsg: '',
      errorMsgShow: false,
      changeForm: {
        id: '',
        network_id: '',
        name: '',
        admin_state_up: true,
        device_id: '',
        device_owner: '',
        fixed_ips: [],
        mac_address: '',
        binding_host_id: '',
        port_security_enabled: true,
        binding_vnic_type: 'normal'
      },
      subNetList: [],
      changeRule: {
        name: [
          { required: true, message: '端口名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModal (networkId, name = '') {
      this.changeForm.network_id = networkId
      this.getSubNetList()
      if (name) {
        this.title = '「' + name + '」创建端口'
      } else {
        this.title = '创建端口'
      }
      this.portEditModal = true
    },
    openModifyModal (id) {
      if (id) {
        detailPrivateCloudPort(id).then(res => {
          const result = res.data.port
          for (let i in this.changeForm) {
            this.changeForm[i] = result[i]
          }
          this.getSubNetList()
          this.title = '「' + result.id + '」编辑端口'
          this.portEditModal = true
        })
      }
    },
    changeSubmit () {
      this.$refs['changeForm'].validate((valid) => {
        if (valid) {
          this.changeLoading = true
          let reqData = JSON.parse(JSON.stringify(this.changeForm))
          if (!reqData.mac_address) {
            delete reqData.mac_address
          }
          for (let v in reqData.fixed_ips) {
            if (!reqData.fixed_ips[v].ip_address) {
              delete reqData.fixed_ips[v].ip_address
            }
          }
          if (!reqData.fixed_ips.length) {
            delete reqData.fixed_ips
          }
          changePrivateCloudPort(reqData, this.changeForm.id).then(res => {
            this.errorMsgShow = false
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('editComplete')
            this.formReset()
            this.changeLoading = false
            this.portEditModal = false
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应'
              this.$Notice.error({
                title: '操作失败！服务器无响应'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 表单重置
    formReset () {
      this.$refs.changeForm.resetFields()
    },
    // 添加固定IP
    addFixedIpItem () {
      this.changeForm.fixed_ips.push({
        subnet_id: '',
        ip_address: ''
      })
    },
    // 移除固定IP
    removeFixedIpItem (index) {
      this.changeForm.fixed_ips.splice(index, 1)
    },
    // 获取子网列表
    getSubNetList () {
      getPrivateCloudAllSubnet({ network_id: this.changeForm.network_id }).then(res => {
        this.subNetList = res.data
      }).catch(res => {
        this.subNetList = []
      })
    }
  }
}
</script>

<style scoped>
  .port-edit-form {
    height: 650px;
    overflow-y: auto;
  }
  .port-edit-form::-webkit-scrollbar {
    width: 5px;
  }
  .port-edit-form::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .port-edit-form::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
</style>
